export default __webpack_public_path__ + "static/media/newLogo1.15074baf.jpg";